import React, { useState, useCallback } from 'react';
import { getApiUrl } from '../authConfig';
import { toast } from 'react-toastify';
import { useTaxPortal } from '../utils/useTaxPortal';
import TaxPortalLayout from '../components/Common/TaxPortalLayout';
import FaxForm from '../components/Common/FaxForm';
import { Link } from 'react-router-dom';
import { getValidToken } from '../utils/msalTokenUtil';

const FaxPage = () => {
  const portalState = useTaxPortal();
  const { account, msalInstance } = portalState;

  const [loading, setLoading] = useState(false);

  const handleSendFax = useCallback(async (formData, resetForm) => {
    setLoading(true);

    try {
      let headers = {};
      if (account) {
        const accessToken = await getValidToken(msalInstance, account);
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      const response = await fetch(getApiUrl('/v1/send-fax'), {
        method: 'POST',
        headers,
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        toast.success(`Success! Your fax has been queued and is now being transmitted.`);
        resetForm();
      } else {
        toast.error(`Could not send fax: ${data.detail || 'The server encountered an error.'}`);
      }
    } catch (err) {
      toast.error(`Connection Error: Unable to reach the fax service. Please check your internet line.`);
    } finally {
      setLoading(false);
    }
  }, [account, msalInstance]);

  return (
    <TaxPortalLayout
      title="CRA Fax Document Portal"
      description="Send tax documents and support files directly to the Canada Revenue Agency."
      portalState={portalState}
    >
      <div className="mb-3">
        <Link to="/fax-dashboard" className="text-decoration-none fw-bold text-primary">← Back to Fax Dashboard</Link>
      </div>

      {account ? (
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="card shadow-sm border-0 rounded-4 mb-4 bg-white position-relative hover-lift">
              <div className="card-body p-3 p-md-5">
                <FaxForm 
                  onSubmit={handleSendFax} 
                  initialSenderName="Ashok Manickam" 
                  initialSenderEmail="fax@orientalbiz.ca" 
                  loading={loading}
                  errorCallback={toast.error}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="alert alert-warning border-start border-warning border-4 shadow-sm">
          Access Denied: Please log in using your user account to access the secure document transmission system.
        </div>
      )}
    </TaxPortalLayout>
  );
};

export default FaxPage;